import Vue from 'vue';

Vue.component('terms-conditions', {
    props: ['version', 'member-id', 'memberProfile', 'successUrl'],

    methods: {
        acceptTermsAndConditions() {
            this.$api.gms.account.acceptTermsAndConditions(this.memberId)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data;
                }
                window.location.href = this.successUrl;
            })
            .catch((error) => {
                console.error(error);
            });
        },
    },
});
